module.exports = __webpack_public_path__ + "static/media/config1.4d95d082.jpg";